import React from 'react'
import numeral from 'numeral'
import { Line } from 'react-chartjs-2';
import { H4 } from './Text'



export const InvestmentReturnGraph = (props) => {
  const irReturnData = {
   
    labels: ["2025", "2026", "2027", "2028", "2029", "2030"],
    datasets: [
      {
        label: 'Practical',
        data: props.valuation.graphData.irPracticalGrowthGraphData,
        fill: false,
        // lineTension: 0.1,
        borderCapStyle: 'butt',
        backgroundColor: 'rgba(0,23,192,0.4)',
        borderColor: 'rgba(0,23,192,1)',
        pointBorderColor: 'rgba(0,23,192,1)',
        pointBackgroundColor: '#fff',
        pointHoverBackgroundColor: 'rgba(0,23,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        
      }, {
        
        label: 'Theoretical',
        fill: false,
        hidden: true,
        // lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        // borderJoinStyle: 'miter',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        // pointHoverBorderWidth: 2,
        // pointRadius: 1,
        // pointHitRadius: 10,
        data: props.valuation.graphData.irPotentialGrowthGraphData,
        
      }, {
        
        label: 'SP500',
        hidden: true,
        data: props.valuation.graphData.irSP500GrowthGraphData,
        fill: false,
        
      }, {
        
        label: 'Trend',
        hidden: true,
        data: props.valuation.graphData.PriceTrendGraphData,
        fill: false,
        backgroundColor: 'rgba(255,174,201,0.4)',
        borderColor: 'rgba(255,174,201,1)',
        pointBorderColor: 'rgba(255,174,201,1)',
        pointBackgroundColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255,174,201,1)',
        pointHoverBorderColor: 'rgba(255,174,201,1)',
        
      }, {
        
        label: 'YoY',
        hidden: true,
        data: props.valuation.graphData.PriceYoYGraphData,
        fill: false,
        backgroundColor: 'rgba(200,191,231,0.4)',
        borderColor: 'rgba(200,191,231,1)',
        pointBorderColor: 'rgba(200,191,231,1)',
        pointBackgroundColor: '#fff',
        pointHoverBackgroundColor: 'rgba(200,191,231,1)',
        pointHoverBorderColor: 'rgba(200,191,231,1)',
      }
    ],
  };
  const irOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    tooltips: {
      mode: 'index',
      callbacks: {
        label: function(tooltipItems, data) {
          let value = tooltipItems.yLabel
          return numeral(value).format('$0,0.00');
        },
      },
    },
    scales: {
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Practical Price'
        },
        ticks: {
          callback: function(value, index, values) {
            return numeral(value).format('$0,0');
          },
          reverse: false
        }
      }]
    }
  };

  return (

    <div className="mb4">
      <div className="w-100 bb bb-0-ns br-ns b--light-gray pa3 br2 cf bg-white shadow-custom">
        <H4> Practical Prices for {props.symbol}</H4>
        <p className="f6 gray">Practical price reflects the gradual alignment of the Market Price with the Practical Valuation.
        Projected SP500 investment return of 7.5% provided for comparison. Assumes dividends are reinvested.</p>
        <Line data={irReturnData} options={irOptions} />
      </div>
    </div>
  )
}

export const SalesGrowthGraph = (props) => {
  const salesGrowthData = {
    labels: ["2025", "2026", "2027", "2028", "2029", "2030"],
    datasets: [{
      label: 'Practical',
      data: props.valuation.graphData.practicalGrowthGraphData,
      fill: false,
      backgroundColor: 'rgba(0,23,192,0.4)',
      borderColor: 'rgba(0,23,192,1)',
      pointBorderColor: 'rgba(0,23,192,1)',
      pointBackgroundColor: '#fff',
      pointHoverBackgroundColor: 'rgba(0,23,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',  
    },{
      label: 'Theoretical',
      hidden: true,
      data: props.valuation.graphData.potentialGrowthGraphData,
      fill: false,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
    }, {
      label: 'SP500',
      hidden: true,
      data: props.valuation.graphData.sp500GrowthGraphData,
      fill: false,
    }, {
        label: 'Trend',
        hidden: true,
        data: props.valuation.graphData.SalesTrendGraphData,
        fill: false,
        backgroundColor: 'rgba(255,174,201,0.4)',
        borderColor: 'rgba(255,174,201,1)',
        pointBorderColor: 'rgba(255,174,201,1)',
        pointBackgroundColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255,174,201,1)',
        pointHoverBorderColor: 'rgba(255,174,201,1)',
      
      }, {
        
        label: 'YoY',
        hidden: true,
        data: props.valuation.graphData.SalesYoYGraphData,
        fill: false,
        backgroundColor: 'rgba(200,191,231,0.4)',
        borderColor: 'rgba(200,191,231,1)',
        pointBorderColor: 'rgba(200,191,231,1)',
        pointBackgroundColor: '#fff',
        pointHoverBackgroundColor: 'rgba(200,191,231,1)',
        pointHoverBorderColor: 'rgba(200,191,231,1)',
      }
    ]
  }
  const salesGrowthOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    tooltips: {
      mode: 'index',
      callbacks: {
        label: function(tooltipItems, data) {
          let value = tooltipItems.yLabel
          return numeral(value).format('$0,0');
        },
      },
    },
    scales: {
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Expected Sales (M)'
        },
        ticks: {
          callback: function(value, index, values) {
            return numeral(value).format('$0,0');
          },
          reverse: false
        }
      }]
    }
  }

  return (
    <div className="w-100 pa3 br2 cf bg-white shadow-custom mb3">
      <H4>Practical Sales Growth for {props.symbol}</H4>
      <p className="f6 gray">Projected SP500 sales growth of 7% provided for comparison.</p>
      <Line data={salesGrowthData} options={salesGrowthOptions} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Graph.js